import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const CartContext = createContext(null);

export const CartProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem("garnacha-cart") || "[]"); } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => { localStorage.setItem("garnacha-cart", JSON.stringify(items)); }, [items]);

  const add = useCallback((p) => {
    setItems((prev) => {
      const i = prev.find((x) => x.product_id === p.id);
      if (i) return prev.map((x) => x.product_id === p.id ? { ...x, quantity: x.quantity + 1 } : x);
      return [...prev, { product_id: p.id, name: p.name, price: p.price, quantity: 1, image: p.image, size: p.size }];
    });
    setOpen(true);
  }, []);

  const updateQty = useCallback((id, qty) => {
    setItems((prev) => prev.map((x) => x.product_id === id ? { ...x, quantity: Math.max(1, qty) } : x));
  }, []);

  const remove = useCallback((id) => {
    setItems((prev) => prev.filter((x) => x.product_id !== id));
  }, []);

  const clear = useCallback(() => setItems([]), []);

  const count = items.reduce((a, b) => a + b.quantity, 0);
  const subtotal = items.reduce((a, b) => a + b.price * b.quantity, 0);

  return (
    <CartContext.Provider value={{ items, open, setOpen, add, updateQty, remove, clear, count, subtotal }}>
      {children}
    </CartContext.Provider>
  );
};

export const useCart = () => useContext(CartContext);
